import {atom} from "recoil";

/**
 * 참조함 문서 count
 * @type {RecoilState<number>}
 */
export const referenceDocTotalCount = atom({
    key: "referenceDocTotalCount"
    , default: 0
})